<div class="input-grid-gaps grid-6col">
    <app-check-input class="fr-2" [form]="form" id="walkoutsChange" [prefix]="prefix"></app-check-input>
    <label
        class="font-bold fr-4">{{ 'sickNotes.doctorReport.labels.forWalkoutsChangesCreateRequestOnDefaultPlace' | translate }}</label>

    <app-date-input [form]="form" id="walkoutsFromDate" [showTime]="false" [prefix]="prefix"
        [disabled]="!form.controls.walkoutsChange.value"></app-date-input>
    <app-date-input [form]="form" id="walkoutsToDate" [showTime]="false" [prefix]="prefix"
        [disabled]="!form.controls.walkoutsChange.value"></app-date-input>
    <app-date-input [form]="form" id="walkoutsFrom1" [timeOnly]="true" [prefix]="prefix"
        [disabled]="!form.controls.walkoutsChange.value || form.controls.walkoutsIndividual.value"></app-date-input>
    <app-date-input [form]="form" id="walkoutsTo1" [timeOnly]="true" [prefix]="prefix"
        [disabled]="!form.controls.walkoutsChange.value || form.controls.walkoutsIndividual.value"></app-date-input>
    <app-date-input [form]="form" id="walkoutsFrom2" [timeOnly]="true" [prefix]="prefix"
        [disabled]="!form.controls.walkoutsChange.value || form.controls.walkoutsIndividual.value"></app-date-input>
    <app-date-input [form]="form" id="walkoutsTo2" [timeOnly]="true" [prefix]="prefix"
        [disabled]="!form.controls.walkoutsChange.value || form.controls.walkoutsIndividual.value"></app-date-input>

    <app-check-input class="fr-6" [form]="form" id="walkoutsIndividual"
        [prefix]="prefix" [disabled]="!form.controls.walkoutsChange.value"></app-check-input>

    <hr class="fr-6">

    <app-check-input [form]="form" id="walkoutsCancel" [prefix]="prefix"></app-check-input>
    <app-date-input [form]="form" id="walkoutsCancelFromDate" [showTime]="false" [prefix]="prefix"
        [disabled]="!form.controls.walkoutsCancel.value"></app-date-input>

    <hr class="fr-6">

    <app-check-input class="fr-6" [form]="form" id="addressChange" [prefix]="prefix"></app-check-input>
    <app-date-input [form]="form" id="addressChangeFromDate" [showTime]="false"
        [disabled]="!form.controls.addressChange.value"
        [prefix]="prefix"></app-date-input>
    <app-date-input [form]="form" id="addressChangeToDate" [showTime]="false"
        [disabled]="!form.controls.addressChange.value"
        [prefix]="prefix"></app-date-input>
    <app-address-input class="fr-4" [form]="form" id="address"
        [disabled]="!form.controls.addressChange.value"
        [prefix]="prefix"
    ></app-address-input>
    <app-text-input class="fr-2" [form]="form" id="addressAddition" [disabled]="!form.controls.addressChange.value"
        [prefix]="prefix"></app-text-input>

    <hr class="fr-6">

    <app-check-input [form]="form" id="diagnosisChange" [prefix]="prefix"></app-check-input>
    <app-date-input [form]="form" id="diagnosisChangeDate" [showTime]="false"
        [disabled]="!form.controls.diagnosisChange.value"
        [prefix]="prefix"></app-date-input>
    <app-diagnosis-select-input
        class="fr-2"
        [form]="form"
        id="diagnosisCode"
        [disabled]="!form.controls.diagnosisChange.value"
        [label]="prefix + 'fields.diagnosisCode'"
    ></app-diagnosis-select-input>

    <hr class="fr-6">

    <app-check-input [form]="form" id="regimeViolation" [prefix]="prefix"></app-check-input>
    <app-text-input class="fr-5" [form]="form" id="regimeViolationNote"
        [disabled]="!form.controls.regimeViolation.value"
        [prefix]="prefix"></app-text-input>

    <hr class="fr-6">

    <app-check-input [form]="form" id="handOver" [prefix]="prefix"></app-check-input>
    <app-date-input [form]="form" id="handOverDate" [showTime]="false"
        [disabled]="!form.controls.handOver.value"
        [prefix]="prefix"></app-date-input>

    <hr class="fr-6">

    <!--    TODO: to bude asi pres jiny form - musim vedet prece koho beru -->
    <!--    <app-check-input [form]="form" id="takeOver" [prefix]="prefix"></app-check-input>-->
    <!--    <app-date-input [form]="form" id="takeOverDate" [showTime]="false"-->
    <!--        [prefix]="prefix"></app-date-input>-->
    <!--    <app-text-input [form]="form" id="takeOverIcpe" [prefix]="prefix"></app-text-input>-->
    <!--    <app-text-input class="fr-3" [form]="form" id="takeOverFromDoctor"-->
    <!--        [prefix]="prefix"></app-text-input>-->
    <!--    <div class="fr-2"></div>-->
    <!--    <app-text-input class="fr-4" [form]="form" id="takeOverCenterName"-->
    <!--        [prefix]="prefix"></app-text-input>-->

    <!--    <hr class="fr-6">-->

    <app-check-input [form]="form" id="hospitalizationChange" [prefix]="prefix"></app-check-input>
    <app-date-input [form]="form" id="hospitalizationChangeFromDate" [showTime]="false"
        [prefix]="prefix"></app-date-input>
    <app-date-input [form]="form" id="hospitalizationChangeToDate" [showTime]="false"
        [prefix]="prefix"></app-date-input>

</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="sickNotes.buttons.sendReport"
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"></app-action-buttons>
</div>
